import { defineStore } from "pinia";
import { directus } from "../services/directus";
import { readItems } from "@directus/sdk";
import { useMenuStore } from "../stores";

/**
 * Hilfsfunktion: Sprache normalisieren
 * Erzwingt Directus-konforme Codes
 */
function normalizeLanguage(lang) {
  if (!lang) return "de-DE";
  if (lang === "de") return "de-DE";
  if (lang === "en") return "en-US";
  return lang;
}

export const usePreferencesStore = defineStore("preferences", {
  state: () => ({
    language:
      typeof window !== "undefined"
        ? normalizeLanguage(localStorage.getItem("lang"))
        : "de-DE",

    givenLanguages: [],
    buttonTypes: [],
  }),

  actions: {
    /**
     * Sprache setzen + abhängige Daten neu laden
     */
    async updateLanguage(language) {
      const normalized = normalizeLanguage(language);

      // Keine unnötigen Reloads
      if (this.language === normalized) return;

      this.language = normalized;

      if (typeof window !== "undefined") {
        localStorage.setItem("lang", normalized);
      }

      // Navigation neu laden (erzwingen!)
      const menuStore = useMenuStore();

      try {
        await menuStore.updateAllNavigations(true); // 🔑 force reload
      } catch (error) {
        console.error("Failed to update navigation after language change:", error);
      }
    },

    /**
     * Verfügbare Sprachen aus Directus laden
     */
    async updateGivenLanguages() {
      try {
        const resp = await directus.request(
          readItems("languages", {
            fields: ["code"],
          })
        );
        this.givenLanguages = resp;
      } catch (error) {
        console.error("Failed to update given languages:", error);
        throw error;
      }
    },

    /**
     * Button-Typen laden
     */
    async updateButtonTypes() {
      try {
        const resp = await directus.request(readItems("button_types"));
        this.buttonTypes = resp;
      } catch (error) {
        console.error("Failed to update button types:", error);
        throw error;
      }
    },
  },
});
